export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050505] border-t border-white/5 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/2af6d988-63de-4022-9613-4edcf52fc5d0.png"
              alt="Logo"
              className="h-10 w-auto object-contain mb-3"
            />
            <p className="text-gray-500 text-sm leading-relaxed">
              El ecosistema definitivo para gestionar tu inventario y finanzas. Operar como un estratega real.
            </p>
          </div>

          <div>
            <p className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Navegación</p>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', id: 'hero' },
                { label: 'Features', id: 'sistemas' },
                { label: 'Pricing', id: 'bonos' },
                { label: 'FAQ', id: 'faq' },
                { label: 'Contact', id: 'contact' },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer text-left whitespace-nowrap"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Soporte</p>
            <div className="flex flex-col gap-3">
              <p className="text-gray-500 text-sm">
                <i className="ri-mail-line mr-2"></i>soporte@superpack.pe
              </p>
              <p className="text-gray-500 text-sm">
                <i className="ri-time-line mr-2"></i>Lun–Vie 9am–6pm
              </p>
              <p className="text-gray-500 text-sm">
                <i className="ri-shield-check-line mr-2 text-[#00FF88]"></i>Acceso seguro y encriptado
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">© 2026 SuperPack · Todos los derechos reservados.</p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-600 hover:text-white text-xs transition-colors cursor-pointer">
              Términos
            </a>
            <a href="#" className="text-gray-600 hover:text-white text-xs transition-colors cursor-pointer">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
